import React from "react";
import PropTypes from "prop-types";
import { Component } from "react";
import { get } from "lodash";
import axios from "axios";

import C from "../../constants";
import HelperContent from "../helperContent/HelperContent";
import QuestionLabel from "../question/QuestionLabel";
import strings from "../../resources/strings";

const appCfg = require("../../config");

var axiosInstance;

class ExternalCall extends Component {    
    componentDidMount() {
        this.resetInstance();
        setTimeout(() => this.callExternalSystem(this.props.store, this.props.question), 1500);
    }

    getMethod() {
        return get(this.props.question, "actionData.method", "GET");
    }

    getBaseUrl() {
        let url = get(this.props.question, "actionData.url");
        if (url === "{server}") {
            return process.env.REACT_APP_SERVER_URL;
        }
        return url;
    }

    getUri() {
        return get(this.props.question, "actionData.uriPath");
    }

    constructPayload(store, question) {
        if (this.props.payloadFunction) {
            return this.props.payloadFunction(store, question);
        }
        
        return {};
    }

    constructQueryString(store, question) {
        if (this.props.queryStringFunction) {
            return this.props.queryStringFunction(store, question);
        }

        return "";
    }

    handleResult(result, store, question) {
        if (this.props.resultFunction) {
            this.props.resultFunction(result, store, question);
        }

        if (this.props.autoAdvance) {
            store.dispatch({ type: C.STORE_RESULT_DATA, result: result.data });
            store.dispatch({ type: C.NEXT_QUESTION });
        }
    }

    handleError(error) {
        console.error(error.message);
        if (this.props.errorFunction) {
            this.props.errorFunction(error);
        }
    }

    callExternalSystem(store, question) {
        let self = this;
        let method = this.getMethod();

        if (method === "GET") {
            let queryString = this.constructQueryString(store, question);
            console.log(this.getBaseUrl() + this.getUri() + "?" + queryString);

            axiosInstance.get(this.getUri() + (queryString ? "?" + queryString : ""))
                .then(function(result) {
                    self.handleResult(result, store, question);
                })
                .catch(function(error) {
                    self.handleError(error);
                })
                .finally(function() {
                    store.dispatch({ type: C.STOP_LOADING });
                });
        }
        else if (method === "POST") {
            let payload = this.constructPayload(this.props.store, this.props.question);
            console.log(this.getBaseUrl() + this.getUri());
            console.log(payload);

            axiosInstance.post(this.getUri(), payload)
                .then(function(result) {
                    self.handleResult(result, store, question);
                })
                .catch(function(error) {
                    self.handleError(error);
                })
                .finally(function() {
                    store.dispatch({ type: C.STOP_LOADING });
                });
        }
    }

    resetInstance() {
        axiosInstance = axios.create({
            baseURL: this.getBaseUrl(),
            timeout: appCfg.serverTimeout,
            headers: {
                "Content-Type": "application/json"
            },
            crossdomain: true,
            //withCredentials: true,
            maxContentLength: 100 * 1024 * 1024 //100MB
        });

        axiosInstance.interceptors.request.use(
            config => {
                console.debug(config.method + " request: " + config.url);
                return config;
            },
            error => {
                console.log(error);
                if (error.code === "ECONNABORTED") {
                    console.error(strings.getString("timeoutErrorCode", error.code));
                }
                throw error;
            }
        );
    
        axiosInstance.interceptors.response.use(
            response => {
                console.log(response);
                return response;
            },
            error => {
                console.log(error);
                if (error.code === "ECONNABORTED") {
                    console.error(strings.getString("timeoutErrorCode", error.code));
                }
                throw error;
            }
        );
    }

    render() {
        let question = this.props.question;

        return (
            <div className="form w3-header w3-animate-opacity">
                <QuestionLabel question={question} store={this.props.store}/>
                <HelperContent question={question} />
            </div>
        )
    }
};

ExternalCall.propTypes = {
    payloadFunction: PropTypes.func,
    resultFunction: PropTypes.func,
    errorFunction: PropTypes.func,
    question: PropTypes.object,
    store: PropTypes.object,
    autoAdvance: PropTypes.bool
};

export default ExternalCall;